
import { useEffect, useState } from 'react';
import './ShareLink.scss';
import { useSelector } from 'react-redux';
import { selectControls } from '../../redux/controls';
import ShareModal from '../Modals/ShareModal/ShareModal';
import { tabToShareBackToPanel } from './models/ShareLink.utils';


interface Props {
  sharingURL: string;
  isEnabled: boolean;
}

export const ShareLink = ({ sharingURL, isEnabled }: Props): JSX.Element => {

  const controls = useSelector(selectControls);
  const [showSharePopper, setShowSharePopper] = useState<boolean>(false);
  const [shareIsOpen, setShareIsOpen] = useState<boolean>(false);

  const clickListener: EventListener = () => {
    //shutdownPopper();
  };

  const escapeKeyListener = (evt: _KeyboardEvent): void => {
    if (evt.key === 'Escape' && !evt.shiftKey) {
      setShowSharePopper(false);
      evt.preventDefault();
    }
  };

  useEffect(() => {
    const hideColumnButton = document.getElementById('show-hide-qp') as HTMLButtonElement;
    const removeListeners = () => {
      hideColumnButton.removeEventListener('click', clickListener, true);
      document.body.removeEventListener('keydown', escapeKeyListener);
    };
    if (isEnabled) {
      hideColumnButton.addEventListener('click', clickListener, true);
      document.body.addEventListener('keydown', escapeKeyListener, true);

      const sharelinkButton = document.getElementById('nqt-shl--show-button') as HTMLElement;
      if (sharelinkButton) {
        sharelinkButton.focus();
      }

    }
    return removeListeners;
  },
  // eslint-disable-next-line
    [sharingURL, isEnabled]);

  // when a modal is open, prevent background scrolling
  // useEffect(() => {
  //   console.log('shareisopen', shareIsOpen);
  //   if(shareIsOpen ){
  //     document.body.classList.add('bg-noscroll');
  //   } else {
  //     if(document.body.classList.contains('bg-noscroll')){
  //       document.body.classList.remove('bg-noscroll');
  //     }
  //   }
  // }, [shareIsOpen]);


  return (
    <div className='nqt-shl-parent' >
      <ShareModal
        open={shareIsOpen}
        onClose={() => setShareIsOpen(false)}
      />
      
      <div className='nqt-shl-inline'>
        <button 
          onClick={() => setShareIsOpen(true)} disabled={!isEnabled}
          id='nqt-shl--show-button'
          aria-label={controls?.ShareTitleText?.controlText}
          className={'button nqt-shl--button ' + (isEnabled ? '' : 'nqt-shl-disabled') + ((showSharePopper ) ? ' nqt-sq--sp-showing' :  '')}  
          onKeyDown={tabToShareBackToPanel}>
          {
            controls?.HideShare?.controlText
          }
        </button>
      </div>
    </div>
  );
};
